import { render, staticRenderFns } from "./EstimatesTable.vue?vue&type=template&id=544a6e75&scoped=true"
import script from "./EstimatesTable.vue?vue&type=script&lang=js"
export * from "./EstimatesTable.vue?vue&type=script&lang=js"
import style0 from "./EstimatesTable.vue?vue&type=style&index=0&id=544a6e75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544a6e75",
  null
  
)

export default component.exports